import React from 'react';
import { get } from 'lodash';
import { ARGENT, GREEN_DARK, WHITE } from '../../../../utils/colors';
import { StatusTag } from '../../../common';

const StatusUserTag = (value) => {
    const tagProps = value.value === '1' ? {
        label: 'Inactivo',        color: ARGENT
    } : {
        label: 'Activo',
        color: GREEN_DARK
    };
    return (
        <StatusTag
            color={WHITE}
            status={get(tagProps, 'label')}
            backgroundColor={get(tagProps, 'color')}
            margin={5}
            fit
        />
    );
};

export default StatusUserTag;
